import OkC from "shared/util/OkcApi";
import _str from "shared/util/_str";

const INITIAL_STATE = {
	hasSeenGreeting: false,

	newName: "",

	realNameIsSubmitting: false,
	realNameIsValidating: false,

	realNameIsValid: true,
	realNameError: "",

	realNameSaved: false,
};

let initialState;

if (typeof window !== "undefined" && window.__PRELOADED_STATE__) {
	initialState = {
		...INITIAL_STATE,
		...window.__PRELOADED_STATE__,
	};
} else {
	initialState = INITIAL_STATE;
}

export const CONFIRM_HAS_SEEN_GREETING = "REALNAMES.CONFIRM_HAS_SEEN_GREETING";

export const UPDATE_NEW_NAME = "REALNAMES.UPDATE_NEW_NAME";

export const VALIDATE_NAME = "REALNAMES.VALIDATE_NAME";
export const VALIDATE_NAME_SUCCESS = "REALNAMES.VALIDATE_NAME_SUCCESS";
export const VALIDATE_NAME_FAILURE = "REALNAMES.VALIDATE_NAME_FAILURE";

export const SAVE_NAME = "REALNAMES.SAVE_NAME";
export const SAVE_NAME_FAILURE = "REALNAMES.SAVE_NAME_FAILURE";
export const SAVE_NAME_SUCCESS = "REALNAMES.SAVE_NAME_SUCCESS";

export const CLEAR_ERRORS = "REALNAMES.CLEAR_ERRORS";

export function reducer(state = initialState, action) {
	switch (action.type) {
		case CONFIRM_HAS_SEEN_GREETING: {
			return {
				...state,
				hasSeenGreeting: true,
			};
		}

		case UPDATE_NEW_NAME: {
			return {
				...state,
				newName: action.payload.newName,
			};
		}

		case VALIDATE_NAME: {
			return {
				...state,
				realNameIsValidating: true,
			};
		}

		case VALIDATE_NAME_FAILURE: {
			return {
				...state,
				realNameIsValid: false,
				realNameError: action.payload.error,
				realNameIsValidating: false,
			};
		}

		case VALIDATE_NAME_SUCCESS: {
			return {
				...state,
				realNameIsValid: true,
				realNameError: "",
				realNameIsValidating: false,
			};
		}

		case SAVE_NAME: {
			return {
				...state,
				realNameSaved: false,
				realNameIsSubmitting: true,
			};
		}

		case SAVE_NAME_FAILURE: {
			return {
				...state,
				realNameError: action.payload.error,
				realNameSaved: false,
				realNameIsSubmitting: false,
			};
		}

		case SAVE_NAME_SUCCESS: {
			return {
				...state,
				realNameSaved: true,
				realNameError: "",
				realNameIsSubmitting: false,
			};
		}

		case CLEAR_ERRORS: {
			return {
				...state,
				realNameError: "",
			};
		}

		default:
			return state;
	}
}

export function updateNewName(newName) {
	return (dispatch) => {
		dispatch({
			type: UPDATE_NEW_NAME,
			payload: {
				newName,
			},
		});

		if (newName === "") {
			dispatch({ type: CLEAR_ERRORS });
		}
	};
}

export function validateRealName(newName) {
	return (dispatch) => {
		dispatch({ type: VALIDATE_NAME });

		// basic name validation
		if (newName.match(/\d/)) {
			dispatch({
				type: VALIDATE_NAME_FAILURE,
				payload: {
					error: _str("Sorry, your name can’t have numbers."),
				},
			});

			return;
		}

		OkC.get("/profile/name/check", {
			data: {
				name: newName,
			},
		}).then(() => {
			dispatch({ type: VALIDATE_NAME_SUCCESS });
		}).catch((err) => {
			dispatch({
				type: VALIDATE_NAME_FAILURE,
				payload: {
					error: err && err.error && err.error.message ?
						err.error.message :
						_str("Names can’t contain special characters."),
				},
			});
		});
	};
}

export function saveRealName(newName) {
	return (dispatch) => {
		dispatch({
			type: SAVE_NAME,
		});

		OkC.put("/profile/name", {
			data: {
				name: newName,
			},
		}).then((res) => {
			if (res.success) {
				dispatch({
					type: SAVE_NAME_SUCCESS,
				});
			}
		}).catch((err) => {
			dispatch({
				type: SAVE_NAME_FAILURE,
				payload: {
					error: err && err.error && err.error.message ?
						err.error.message :
						_str("Something went wrong. Please try again"),
				},
			});
		});
	};
}

export const onConfirmHasSeenGreeting = () => {
	return {
		type: CONFIRM_HAS_SEEN_GREETING,
	};
};



// WEBPACK FOOTER //
// ./src/ducks/realnames.js